import React from "react";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import styles from "../styles/CreatorSidebar.module.scss";
import { CiUser } from "react-icons/ci";
import { FiBarChart2, FiPackage, FiSettings } from "react-icons/fi";
import { TbGridPattern } from "react-icons/tb";
import { BiHome, BiLogOutCircle } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../../actions/authActions";

interface NavItem {
  labelId: string;
  path: string;
  icon: React.ReactNode;
}

const navItems: NavItem[] = [
  { labelId: "creator.sidebar.dashboard", path: "/creator/dashboard", icon: <FiBarChart2 /> },
  { labelId: "creator.sidebar.orders", path: "/creator/orders", icon: <CiUser /> },
  { labelId: "creator.sidebar.finance", path: "/creator/finance", icon: <FiPackage /> },
  { labelId: "creator.sidebar.analytics", path: "/creator/analytics", icon: <TbGridPattern /> },
  { labelId: "creator.sidebar.promotions", path: "/creator/promotions", icon: <FiSettings /> },
  { labelId: "creator.sidebar.messages", path: "/creator/messages", icon: <FiSettings /> },
  { labelId: "creator.sidebar.settings", path: "/creator/settings", icon: <FiSettings /> },
];

const CreatorSidebar  = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  const location = useLocation();
  const state = location.state
  const handleLogout = () => {
    dispatch(logoutUser());
    navigate('/')
  }
  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
         <Link className={styles.logo} to={"/"}>
                        <img src="/icons/sewlight-logo.svg" alt="sewlight" />
                    </Link>
        <div className={styles.brand}>
          <span className={styles.brandBadge}>Creator</span>
          <span className={styles.brandName}>Portal</span>
        </div>

        <nav className={styles.nav}>
          {navItems.map(({ labelId, path, icon }) => (
            <NavLink
              key={path}
              to={path}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.navItemActive : ""}`
              }
            >
              <span className={styles.navIcon}>{icon}</span>
              <span className={styles.navLabel}>
                {intl.formatMessage({ id: labelId, defaultMessage: labelId })}
              </span>
              <span className={styles.navIndicator} />
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.footerDivider} />
            <button
            className={`${styles.navItem} ${styles.logoutButton}`}
            onClick={() => {
              if(state?.from?.startsWith('/profile/')) {
               navigate(state.from)
              } else {
                navigate('/')
              }
            }}
          > <span className={styles.navIcon}><BiHome /></span>
            <span className={styles.navLabel}>
              {state?.from?.startsWith('/profile/')
                ? intl.formatMessage({ id: "creator.sidebar.backToProfile", defaultMessage: "Back to Profile" })
                : intl.formatMessage({ id: "creator.sidebar.backToHome", defaultMessage: "Back to Home" })}
            </span>
            <span className={styles.navIndicator} /></button>
          <button
            className={`${styles.navItem} ${styles.logoutButton}`}
            onClick={handleLogout}
          >
            <span className={styles.navIcon}><BiLogOutCircle /></span>
            <span className={styles.navLabel}>{intl.formatMessage({ id: "creator.sidebar.logout", defaultMessage: "Log out" })}</span>
            <span className={styles.navIndicator} />
          </button>
        </div>
      </aside>

      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default CreatorSidebar;